import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

type IdNamePair = { id: string; name: string };

type SpeciesAutocompleteProps = {
    species: IdNamePair[];
    selectedSpecies: IdNamePair | null;
    onSpeciesChange: (species: IdNamePair | null) => void;
};

export function SpeciesAutocomplete({ species, selectedSpecies, onSpeciesChange }: SpeciesAutocompleteProps) {
    const { t } = useTranslation("mapEditor");

    return (
        <Autocomplete
            fullWidth
            options={species}
            getOptionLabel={option => option.name}
            value={selectedSpecies}
            onChange={(_, newValue) => onSpeciesChange(newValue)}
            renderInput={params => (
                <TextField {...params} label={t("mapEditorFeatureCreateDialog.observationSection.labelSpecies")} />
            )}
            noOptionsText={t("mapEditorFeatureCreateDialog.observationSection.labelNoSpecies")}
        />
    );
}
